
export const ENV = {
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || '',
  COREAPI_DOMAIN: process.env.VUE_APP_COREAPI_BASE_URL || '',
  BACKEND_URL: process.env.VUE_APP_BACKEND_URL || '',
  BASE_URL: process.env.BASE_URL || '/',
  CORE_URL: process.env.VUE_APP_CORE_URL || '',
  ENV: process.env.VUE_APP_ENV || ''
}